import * as echarts from "echarts";
import { useEffect, useRef } from "react";

const PieChart = ({
  width,
  height,
  radius = "100%",
  center = ["50%", "60%"],
  data,
  showReportCheckbox=false
}) => {
  const chartRef = useRef(null);
  let isReporting = false;
  if (typeof window !== "undefined" && window.location) {
    const searchParams = new URLSearchParams(window.location.search);
    isReporting = searchParams.get("isReporting") === "true";
  }
  const COLOR_RANGES = [
    { start: 0, end: 30, color: "#e76262" },
    { start: 30, end: 50, color: "#f9cf4a" },
    { start: 50, end: 70, color: "#eca336" },
    { start: 70, end: 100, color: "#3ece80" },
  ];

  // knob color helper
  function getKnobColor(value) {
    const range = COLOR_RANGES.find(r => value <= r.end);
    return range ? range.color : COLOR_RANGES[COLOR_RANGES.length - 1].color;
  }

  // gauge line colors with small separator gaps
  const axisColors = COLOR_RANGES.flatMap((r, i) => {
    const endRatio = r.end / 100;
    const gap = 0.04; // separator thickness
    return i === COLOR_RANGES.length - 1
      ? [[endRatio, r.color]]
      : [[endRatio, r.color], [endRatio + gap]];
  });

  useEffect(() => {
    let chart = echarts.init(chartRef.current);

    const option = {
      series: [
        {
          data: data,
          type: "gauge",
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: 100,
          splitNumber: 3,
          radius: radius,
          center: center,
          animationDuration:(isReporting||showReportCheckbox) ? 0: 4000,
          animationEasing: "exponentialOut",
          pointer: {
            icon: "circle",
            length: "14%", //knob size
            width: 110,
            offsetCenter: [0, "-88.5%"], // knob adjustment
            itemStyle: {
              color: "#FFFFFF",
              borderColor: getKnobColor(data[0].value),
              borderWidth: 10,
              // shadowColor: "rgba(10, 31, 68, 0.5)",
              // shadowBlur: 2,
              // shadowOffsetY: 1,
            },
          },
          axisLine: {
            show: true,
            roundCap: true,
            lineStyle: {
              width: 18, //track width
              color: axisColors
            },
          },
          axisTick: {
            length: 2,
            lineStyle: {
              color: "#8a94a6",
              width: 2,
            },
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          title: {
            show: false,
          },
          detail: {
            rich: {
              header: {
                fontSize: 58,
                fontWeight: 700,
                fontFamily: "Inter",
                color: "#0a1f44",
              },
              subHeader: {
                fontSize: 16,
                fontWeight: 400,
                fontFamily: "Open Sans",
                color: "#8a94a6",
              },
            },
            // formatter: ["{header|{value}}", "{subHeader|15-30-2022}"].join(
            //   "\n"
            // ),
            formatter: ["{header|{value}}"].join("\n\n"),
            offsetCenter: [0, "-20%"],
            valueAnimation: true,
          },
        },
      ],
    };

    chart.setOption(option);

    // Listen for a custom event 'tabchange' on window and update the chart
    function handleTabChange(e) {
      setTimeout(() => {
      chart.setOption(option);
      chart.resize();
      });    }

    window.addEventListener('tabchange', handleTabChange);

    // Cleanup event listener on unmount
    return () => {
      chart.dispose();
      window.removeEventListener('tabchange', handleTabChange);
    };

  }, [data[0].value]);

  return (
    <div ref={chartRef} style={{ width, height }} />
  );
};

export default PieChart;
